import styled from 'styled-components';

import { Button } from 'components/Button';

const Create = styled(Button)`
  width: fit-content;
  margin: 2rem 0;
`;

// all page actions on the right: closed budget export, then "Add new Budget"
const CreateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
  width: 100%;
  justify-content: flex-end;
`;
export { Create, CreateWrapper };
